module.exports = __webpack_public_path__ + "img/mobile_map_penalonen.b68c8836.svg";